export const identityNumberMaxLength = 13;
export const firstNameOrSurnameMinLength = 2;
export const firstNameMinLength = 2;
export const firstNameMaxLength = 43;
export const surnameMinLength = 2;
export const surnameMaxLength = 43;
export const initialMaxLength = 10;
export const designationMaxLength = 100;
export const codeMinLength = 5;

export const brokerConsultantFullNameMaxLength = 150;

export const passportNumberMaxLength = 15;
export const passportNumberMinLength = 2;

export const trustNumberMaxLength = 30;
export const trustNameMinCharacterLength = 2;
export const trustNameMaxLength = 43;
export const trustNameMaxLengthBankVerificationTesting = 100;

export const emailAddressMinLength = 6;
export const emailAddressMaxLength = 80;
export const phoneNumberMinLength = 9;
export const phoneNumberMaxLength = 20;

export const southAfricanTaxNumberMaxLength = 10;
export const otherTaxNumberMaxLength = 25;
export const cantObtainTaxNumberReasonMaxLength = 280;

export const businessActivityMaxLength = 100;
export const otherSourceOfWealthMaxLength = 100;
export const otherNatureOfIncomeMaxLength = 100;
export const occupationMinLength = 2;
export const occupationMaxLength = 100;
export const employerMinLength = 2;
export const employerMaxLength = 100;
export const otherIndustrySectorMinLength = 2;
export const otherIndustrySectorMaxLength = 100;
export const giiNumberLength = 19;

export const investmentNameMaxAllowedCharacters = 150;
export const planNumberMaxAllowedCharacters = 50;
export const sourceProviderNameMaxLength = 150;
export const commentsMaxAllowedCharacters = 150;

// IAP Validation Limits
export const IAPFirstNameMaxLength = 60;
export const IAPSurnameMaxLength = 60;

export const IAPOrganisationMinCharacterLength = 2;
export const IAPOrganisationMaxCharacterLength = 200;
export const IAPOrganisationMaxRegistrationLength = 50;
export const IAPOrganisationMaxRegistrationLengthZA = 14;

export const IAPPassportNumberMaxLength = 50;
export const minimumTaxPercentage = 0;
export const maximumTaxPercentage = 45;

export const minimumCompanyDateOfIncorporation = new Date(Date.UTC(1800, 0, 1));

// IAP investment details recurring contribution validation limits
export const minimumDebitOrderDateDaysInAdvance = 5;
export const maximumDebitOrderDateMonthsInAdvance = 6;
export const annualGrowthRatePercentageMin = 0.01;
export const annualGrowthRatePercentageMax = 100;

// IAP Address fields limits
export const poBoxNumberMaxLength = 50;
export const suiteMaxLength = 150;
export const privateBagNumberMaxLength = 50;
export const unitNumberMaxLength = 15;
export const complexNameMaxLength = 150;
export const streetPlotOrFarmNameMaxLength = 150;
export const streetOrFarmNumberMaxLength = 15;
export const suburbOrDistrictMaxLength = 150;
export const cityOrTownMaxLength = 150;
export const provinceMaxLength = 150;
export const postalCodeMaxLength = 36;
export const inCareOfFullNameMaxLength = 300;

export const unitTransferInvestmentNumberMaxLength = 50;
export const unitTransferPercentageMax = 100;

export const internalTransferInvestmentNameMaxLength = 150;
export const internalTransferInvestmentNumberMaxLength = 50;

export const newSourceOfMoneyMaxLength = 100;

export const internalInvestmentNameMaxLength = 150;
export const payeeNameAndSurnameMaxLength = 60;
export const internalInvestmentNumberMaxLength = 50;

// Number of third party types allowed
export const maxFinancialContributors = 10;
export const maxBeneficiaries = 20;
export const maxAlternativeBeneficiaries = 20;
export const maxLivesInsured = 10;
export const maxOtherLivesInsured = 20;
export const maxNomineesForOwnership = 1;
export const maxNominees = 20;
export const maxPayees = 10;

// Bank account field limits
export const accountNumberMaxLength = 20;

export const accountNameMaxLength = 60;

//Just portfolio step 5 substep limits
export const quoteNumberMaxLength = 50;

export const minPhaseInDaysInFuture = 7;
export const phaseInFrequencyMonthly = 12;
export const phaseInFrequencyQuarterly = 4;
export const minPhaseInOccurences = 1;
export const phaseInFundToMaxPercentage = 100;

export const proposalSearchMaxhLength = 300;
